import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

export type ToastType = 'success' | 'error';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('toastAnimation', [
            transition(':enter', [
                style({
                    opacity: 0,
                    transform: 'translateY(-20px)'
                }),
                animate('200ms ease-out', style({
                    opacity: 1,
                    transform: 'translateY(0)'
                }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({
                    opacity: 0,
                    transform: 'translateY(-20px)'
                }))
            ])
        ])
    ]
})
export class ToastComponent implements OnInit {
    @Input() message: string = '';
    @Input() type: ToastType = 'success';
    @Input() duration: number = 3000;

    @Input()
    get visible(): boolean {
        return this._visible;
    }
    set visible(value: boolean) {
        this._visible = value;
        this.visibleChange.emit(value);
    }
    private _visible: boolean = false;

    @Output() visibleChange = new EventEmitter<boolean>();

    ngOnInit(): void {
        if (this.visible && this.duration > 0) {
            setTimeout(() => {
                this.visible = false;
            }, this.duration);
        }
    }

    getBackgroundColor(): string {
        return this.type === 'success' ? '#4CAF50' : '#F44336';
    }
}